import moment from 'moment';

export default {
    renderTimer: time => {
        if (!time) {
            return '';
        }

        if (moment().diff(moment(time), 'hours') >= 1) {
            return '+1h';
        }

        return moment(moment().diff(moment(time))).format('mm:ss');
    },


    renderDeliveryDateTimer: function (order) {
        if (!order){
            return '';
        }


        const deliveryDate = (order.deliveryDate ? moment(order.deliveryDate) : order.requestDate ? moment(order.requestDate) : null);

        if (deliveryDate === null){
            return '';
        }

        return deliveryDate.format('HH:mm');
    },
};



// WEBPACK FOOTER //
// ./src/script/utils/time.js